<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron @click="$router.push({name: 'Workspace'})"/>
                Biomarcadores pendientes (fallo de nombre)
              </h1>
            </div>
          </grid-col>
        </grid-row>

        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="notFoundTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="id"
                :hidden="true"
                :filterable="false"
                data-type="boolean">
              </table-column>

              <table-column
                show="name"
                label="Nombre extraido"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                show="unit"
                label="Unidad"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                show="value"
                label="Valor"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                label="Resolver"
                :sortable="false"
                :filterable="false"
                header-class="text-left"
                cell-class="table-component__text-left">
                <template slot-scope="row">
                  <div style="display: flex; gap: 10px; align-items: center;">
                    <select
                      class="resolver-select"
                      :value="selectedOptionByNotFoundId[row.id] || ''"
                      @change="onResolutionChange(row, $event.target.value)">
                      <option disabled value="">Selecciona biomarcador...</option>
                      <option
                        v-for="candidate in row.candidates"
                        :key="candidate.biomarkerId"
                        :value="candidate.biomarkerId">
                        {{ candidate.description }} ({{ candidate.unit }})
                      </option>
                    </select>

                    <button
                      class="btn btn-success btn-sm"
                      @click="onAccept(row)">
                      Aceptar
                    </button>

                    <button
                      class="btn btn-danger btn-sm"
                      @click="onReject(row)">
                      Rechazar
                    </button>
                  </div>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Chevron from '@/components/shared/Chevron';
import AnalyticsService from 'BRAND/api/analytics';

export default {
  name: 'NotFoundBiomarkersNameList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    Chevron
  },
  data () {
    return {
      notFoundBiomarkers: [],
      selectedOptionByNotFoundId: {},
      breadcrumb: [
        {link: '/workspace', name: 'Workspace'},
        {link: '/analytics/not-found/names', name: 'Biomarcadores no encontrados', disabled: true}
      ],
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  created () {
    this.requestNotFoundBiomarkers();
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb;
    }
  },
  methods: {
    fetchData ({page, filter, sort}) {
      const tablePage = pagination.createPage(
        this.notFoundBiomarkers,
        this.tableState,
        ['name', 'unit', 'value'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },

    async requestNotFoundBiomarkers () {
      try {
        const rawData = await AnalyticsService.getNotFoundNames(this);

        const dataArray = Array.isArray(rawData) ? rawData : (rawData.data || []);

        this.notFoundBiomarkers = dataArray.map(item => {
          return {
            ...item,
            value: item.value != null ? String(item.value) : ''
          };
        });

        this.refreshTable();
      } catch (error) {
        console.error("Error al cargar los biomarcadores pendientes:", error);
      }
    },

    refreshTable () {
      this.$nextTick(() => {
        if (this.$refs.notFoundTable) {
          this.$refs.notFoundTable.refresh();
        }
      });
    },

    onResolutionChange (row, selectedBiomarkerId) {
      this.$set(this.selectedOptionByNotFoundId, row.id, selectedBiomarkerId);
    },

    async onAccept (row) {
      const selectedBiomarkerId = this.selectedOptionByNotFoundId[row.id];
      if (!selectedBiomarkerId) {
        alert("Por favor, selecciona un biomarcador del desplegable primero.");
        return;
      }

      try {
        await AnalyticsService.resolveName(this, row.id, selectedBiomarkerId);

        this.notFoundBiomarkers = this.notFoundBiomarkers.filter(item => item.id !== row.id);
        this.$delete(this.selectedOptionByNotFoundId, row.id);
        this.refreshTable();
      } catch (error) {
        console.error("Error al resolver biomarcador:", error);
        alert("No se pudo guardar la resolución.");
      }
    },

    async onReject (row) {
      if (!confirm(`¿Estás seguro de que quieres rechazar '${row.name}'?`)) return;

      try {
        await AnalyticsService.rejectBiomarker(this, row.id);

        this.notFoundBiomarkers = this.notFoundBiomarkers.filter(item => item.id !== row.id);
        this.$delete(this.selectedOptionByNotFoundId, row.id);
        this.refreshTable();
      } catch (error) {
        console.error("Error al rechazar biomarcador:", error);
        alert("No se pudo rechazar el biomarcador.");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/stylesheets/variables";

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}

.header-title {
  float: left;
}

.resolver-select {
  min-width: 220px;
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  padding: 0.35rem 0.5rem;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/analytics/NotFoundBiomarkersNameList.vue